import { questions } from "../utils/constants"



export const getScore = (qnId, answer) => {
    let score = 0


    if (qnId == 1) {
        questions[1].choices.forEach((choice, id) => {
            if (answer == choice) {
                score = id + 1
            }
        })
    } else if ([2, 5,  6, 8, 9].includes(qnId)) {
        score = Number(answer)
    } else if ([3, 4, 7].includes(qnId)) {
        score = 10 - Number(answer)
    }



    return score
}